// extracted by mini-css-extract-plugin
export default {"notification_count":"HeaderNotification_notification_count__2vLFx"};